/** Public stats + YouTube video statistics refresh interval (5 minutes). */
export const PUBLIC_STATS_REFRESH_MS = 5 * 60 * 1000;
//# sourceMappingURL=statsConstants.js.map